<ngb-toast *ngIf="showToast" aria-live="polite" aria-atomic="true"
  [ngClass]="{ 'success-toast': typeToast, 'fail-toast': !typeToast }" [autohide]="true" (hidden)="!showToast">

  <img src="assets/img/{{typeToast ? 'success-icon' : 'fail-icon'}}.png" class="toast-icon" />
  <span class="toast-message">
    {{ "toast." + messageToast | translate }}

  </span>
  <img src="assets/img/close-icon.png" class="toast-close" (click)="close()" />

</ngb-toast>